// src/pages/MainDashboard.js
import React, { useEffect, useState, useRef, useContext, useMemo } from "react";
import NavBarTop from '../../NavBar_Top/NavBar_Top';
import Rodape from '../../Rodape/Rodape';
import { BrowserView, MobileView } from 'react-device-detect';
import { ToastContainer, toast } from 'react-toastify';
import { Grid, Box } from "@material-ui/core";
import { TextField } from "@mui/material";
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { MyContext } from '../../../context/MyContext';
import { useTheme, ThemeProvider, createTheme } from "@mui/material/styles";
import { DataGrid } from '@mui/x-data-grid';
import api from '../../../services/api';
import * as locales from '@mui/material/locale';
import { styled } from "@mui/material/styles";
import Paper from '@mui/material/Paper';
import { ReactComponent as UsuarioIcon } from '../../../assets/img/profileNAFIL.svg';
import { ReactComponent as ChaveIcon } from '../../../assets/img/chave.svg';
import OtpInput from "react-otp-input";
import axios from 'axios';
// import DashboardCadastro from '../../../components/Pages/Cadastro/Cadastro';
import PaginaCadastro from '../../../components/Pages/Cadastro/Cadastro';
//import PaginaCadastro from '../../../components/CadastroUsuario/CadastroUsuario';
//import DashboardDadosPessoais from '../../../components/DadosPessoais/ModalDadosPessoais';
import ModalEnderecos from '../../../components/Pages/Enderecos/ModalEndereco';
import ModalContatos from '../../../components/Pages/Contatos/ModalContato';
import Typography from "@mui/material/Typography";
import { useNavigate, Link } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import InputMask from 'react-input-mask';
import { useHistory } from 'react-router-dom';
import { minWidth } from "@mui/system";
import { useLocation } from 'react-router-dom';

//// import DashboardEndereco from '../../../components/Pages/MinhaConta/DashEndereco';
// import DashboardContato from "/NAFIL_/Site/dotNetFonte/SiteNafil-FrontEnd/src/components/Pages/MinhaConta/DashCadastro";
// import MinhaConta from './../MinhaContaOLD/MinhaConta';
// import { DashboardCadastro } from '/NAFIL_/Site/dotNetFonte/SiteNafil-FrontEnd/src/components/Pages/MinhaConta/DashCadastro';
// import DashCadastro from './../MinhaContaOLD/DashCadastro';
// import CadastroUsuario from './../../CadastroUsuario/CadastroUsuarioJoao';
// import CadastroUsuario from './../../CadastroUsuario/CadastroUsuarioJoao';
// import Contatos from './../MinhaContaOLD/ComponentesDoMenu/Contatos';
// <PaginaCadastro />

export default function MinhaConta(props) {  
  const history = useHistory();
  const {nomeUsuarioLogado, setNomeUsuarioLogado} = useContext(MyContext); // Armazena Criptografado o Nome do Usuário Logado
  // const [nomeUsuarioLogado, setNomeUsuarioLogado] = useState(""); // Armazena Criptografado o Nome do Usuário Logado    
  // const [open, setOpen] = React.useState(false);
  // const [openDadosPessoais, setOpenDadosPessoais] = React.useState(false);
  const { openDadosPessoais, setOpenDadosPessoais } = useContext(MyContext);
  const [openMeusEnderecos, setOpenMeusEnderecos] = React.useState(false);
  const [openMeusContatos, setOpenMeusContatos] = React.useState(false);
  const [locale, setLocale] = useState('ptBR');
  const theme = useTheme();
  const themeWithLocale = useMemo(() => createTheme(theme, locales[locale]), [locale, theme]);
  const [email, setEmail] = useState('');
  const [reEmail, setReEmail] = useState('');
  const [cpf_cnpj, setCpf_Cnpj] = useState('');
  const [labelCpf_Cnpj, setLabelCpf_Cnpj] = useState("CPF:");
  const [maskCpf_Cnpj, setMaskCpf_Cnpj] = useState("999.999.999-99");
  const [ie_Rg, setIe_Rg] = useState('');
  const [razao_social, setRazao_Social] = useState('');  
  const [existemErros, setExistemErros] = useState('');
  const [naoEditarFaturado, setNaoEditarFaturado] = useState(false);
  const [showingToast, setShowingToast] = useState(0);
  const [showingToastNeedLogin, setShowingToastNeedLogin] = useState(1);  
  const { destinoPagina, setDestinoPagina } = useContext(MyContext);
  // const [usuarioLogado, setUsuarioLogado] = useState("");  // Armazena Criptografado o Id e Loja do Cliente  
  const { usuarioEfetuouLogin, setUsuarioEfetuouLogin } = useContext(MyContext);
  const { showModalDadosPessoais, setShowModalDadosPessoais } = useContext(MyContext);
  const { aguardandoCodigoVerificacao, setAguardandoCodigoVerificacao } = useContext(MyContext);
  // const { usuarioEfetuouLoginEMail, setUsuarioEfetuouLoginEMail } = useContext(MyContext);
  const { usuarioEfetuouLoginEMail, setUsuarioEfetuouLoginEMail } = useContext(MyContext);
  const [ editandoDadosPessoais, setEditandoDadosPessoais ] = React.useState(false);
  const [ exibirCodigoVefificacao, setExibirCodigoVefificacao ] = React.useState(false);
  const [otp, setOtp] = React.useState("");
  const [codigoAcesso, setCodigoAcesso] = React.useState("");
  const [message, setMessage] = useState("Aguarde...");  
  const location = useLocation();
  let navigate = useHistory();

  const handleChange = (value) => {
    if (/^[0-9]?$/.test(value)) {
      //const newCode = [...codigoAcesso];
      //newCode[index] = value;
      //setCode(newCode);

      // Foco automático no próximo campo
      //if (value && index < 5) {
     //   inputs.current[index + 1].focus();
     // }
     //setCodigoAcesso(value);
    }
    setOtp(value);
    setMessage("");
    setCodigoAcesso(value);
  };
  
//   useEffect(() => {
//     // if (aguardandoCodigoVerificacao){
//     //   //setExibirCodigoVefificacao(true);  
//     //   console.log("VACA -8888", aguardandoCodigoVerificacao);
//     // }
//     // else{
      
// //      setOpenDadosPessoais(true);

// //      console.log("NOMEZ", usuarioEfetuouLogin);

//     //}    
//   }, [showModalDadosPessoais]);

  useEffect(() => {
    if (usuarioEfetuouLogin == "" || usuarioEfetuouLogin.length == 0){
      setDestinoPagina("verificacao");
      navigate.push('/login');
    } else if (usuarioEfetuouLoginEMail != "" && usuarioEfetuouLoginEMail.length > 4 && aguardandoCodigoVerificacao == true){
      handleBotaoReenviar();
      setDestinoPagina("verificacao");
    }
    else if (aguardandoCodigoVerificacao == false){
      setDestinoPagina("minha_conta");
    }
    else{
      setDestinoPagina("login");
    }
  }, []);
  
  // useEffect(() => {    
  //   // if (usuarioEfetuouLoginEMail == "" || usuarioEfetuouLoginEMail.length < 4){
  //   //   console.log("VACAaaaaaaZZZ", openDadosPessoais, aguardandoCodigoVerificacao);
  //   //   setDestinoPagina("login");
  //   //   navigate.push('/login');
  //   // } else if (aguardandoCodigoVerificacao){
  //   //   console.log("VACAaaaaaaYYYY", openDadosPessoais, aguardandoCodigoVerificacao);      
  //   //   setDestinoPagina("verificacao");
  //   //   console.log("VACAaaaaab", openDadosPessoais, aguardandoCodigoVerificacao, usuarioEfetuouLoginEMail);    
  //   //   navigate.push('/verificacao');
  //   // }else if (openDadosPessoais){
  //   //   console.log("VACAaaaaaaWWWW", openDadosPessoais, aguardandoCodigoVerificacao);
  //   //   setDestinoPagina("minha_conta");
  //   //   navigate.push('/minha_conta');
  //   // }
  //   // else{
  //   //   console.log("VACAaaaaaaQQQQQ", openDadosPessoais, aguardandoCodigoVerificacao);
  //   //   setDestinoPagina("login");
  //   //   navigate.push('/login');
  //   // }
  //   console.log("VACAaaaaac", openDadosPessoais, aguardandoCodigoVerificacao);      
  // }, [openDadosPessoais]);  

  // setUsuarioLogado(sessionStorage.getItem("id_loja_usuario"));
  // let usuarioComprasFaturado = sessionStorage.getItem("usuario_compras_faturado");
  // let usuarioLogado = sessionStorage.getItem("id_loja_usuario");

  // if (usuarioLogado != null && usuarioLogado != "" && usuarioLogado.length != 0){
  //   usuarioLogado = identificacaoUsuarioLogado(usuarioLogado);        
  // } 

  const toastMensagemErrorLogin = (message) => toast.error(message, { position: toast.POSITION.BOTTOM_CENTER, theme: "colored", autoClose: 2000 });

  const handleOpenDadosPessoais = () => {
    if (showModalDadosPessoais == false){
      BuscarMeusDadosPessoais();
      // VOLTAR setShowModalDadosPessoais(true);     
    }
  }

  const handleCloseDadosPessoais = () => {
    // setOpenDadosPessoais(false);
    setShowModalDadosPessoais(false);
  }

  const handleSalvarDadosPessoais = () => {
    if (razao_social == null || razao_social == "" || razao_social.length < 5){
      setExistemErros("Digite Seu Nome Completo...");
      return;
    }
    setOpenDadosPessoais(false);
    setShowModalDadosPessoais(false);
  }

  const toastLoginSucesso = (nome) => toast.success("Bem Vindo, " + nome,
        { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

  const handleBotaoVerificar = async () => {
    try {           
      const res = await axios.post("https://whats.nafil.com.br/api/Acessos/verify-code", { usuarioEfetuouLoginEMail, codigoAcesso });
      if (res.data.success) {
        setMessage("Acesso autorizado!");
        toastLoginSucesso(nomeUsuarioLogado.split(' ').slice(0, 2).join(' '));
        setAguardandoCodigoVerificacao(false);
        // setShowModalDadosPessoais(true);
        setOpenDadosPessoais(true);
        navigate.push('/minha_conta');
      }
    } catch (err) {
      setMessage(err.response?.data || " - Código Inválido.");
    }
  };

  const handleOpenMeusEnderecos = () => {
    setOpenMeusEnderecos(true);
  }

  const handleCloseMeusEnderecos = () => {
    setOpenMeusEnderecos(false);
  }

  const handleOpenMeusContatos = () => {
    setOpenMeusContatos(true);
  }

  const handleCloseMeusContatos = () => {
    setOpenMeusContatos(false);
  }

  function BuscarMeusDadosPessoais() {
    if (usuarioEfetuouLogin == null || usuarioEfetuouLogin == "" || usuarioEfetuouLogin.length == 0){
      return; 
    }
    if(usuarioEfetuouLogin.indexOf('_') == -1){
      return; 
    }
    api.get(`/Clientes/ClienteInfo/` + usuarioEfetuouLogin.split('_')[0] + `/` + usuarioEfetuouLogin.split('_')[1])
      .then((response) => {        
        if (response === null){
          return; 
        }
        setRazao_Social(response.data.nome);
        setCpf_Cnpj(response.data.cpf);
        setIe_Rg(response.data.ie_Rg);
        setEmail(response.data.contatos[0].email);
        setReEmail(response.data.contatos[0].email);
      })
      .catch((error) => {
        console.log(error.message)
      });
  }

  const style = {
    position: 'absolute',
    top: '25%',
    left: '10%',
    right: "10%",
    overflow: 'scroll',
    height: '100%',
    display: 'block',
    bgcolor: 'background.paper',
    boxShadow: 24
  }   

  const handleEmail = (e) => {
    setEmail(e.target.value);    
  }

  const handleReEmail = (e) => {
    setReEmail(e.target.value);
  }

  const handleCpfCnpj = (e) => {
    setCpf_Cnpj(e.target.value);
  }

  const handleIe_Rg = (e) => {
    setIe_Rg(e.target.value);
  }

  const handleRazao_Social = (e) => {
    setRazao_Social(e.target.value);
  }  

  const handleBotaoCancelar = (e) => {
    setDestinoPagina('home');
    history.push("/home");    
  }

  const handleBotaoReenviar = (e) => {
    if (usuarioEfetuouLoginEMail.length > 3){
      enviarCodigo(e);
    }
    else{
      setDestinoPagina("verificacao");
      history.push("/login");    
    }    
  }

  function mascararEmail(email, { userVisible = 1, domainVisible = 1, keepTLD = true, maskChar = "*" } = {}) {
    if (!email || typeof email !== "string") return "";
  
    const atIndex = email.lastIndexOf("@");
    if (atIndex === -1) return email;
  
    const local = email.slice(0, atIndex);
    const domainFull = email.slice(atIndex + 1);
  
    // separar domínio do TLD
    let domainName = domainFull;
    let tld = "";
    const lastDot = domainFull.lastIndexOf(".");
    if (lastDot > 0 && keepTLD) {
      domainName = domainFull.slice(0, lastDot);
      tld = domainFull.slice(lastDot);
    }
  
    // quantidade de caracteres a mascarar (garantindo >=0)
    const maskedLocalLength = Math.max(local.length - userVisible, 0);
    const maskedDomainLength = Math.max(domainName.length - domainVisible, 0);
  
    const maskedLocal = maskChar.repeat(maskedLocalLength);
    const maskedDomain = maskChar.repeat(maskedDomainLength);
  
    const visibleLocal = local.slice(0, userVisible);
    const visibleDomain = domainName.slice(0, domainVisible);
  
    return `${visibleLocal}${maskedLocal}@${visibleDomain}${maskedDomain}${tld}`;
  }
  
  const enviarCodigo = async () => {
    try {
      // monta o objeto JSON
      const data = { "Email": usuarioEfetuouLoginEMail };

      // envia para a API
      const response = await axios.post("https://whats.nafil.com.br/api/Acessos/send-code", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setMessage("Código enviado com sucesso!");
    } catch (error) {
      setMessage(
        error.response?.data || "Ocorreu um erro ao enviar o código"
      );
    }
  };
  
  const deslogar = async (event) => {
    sessionStorage.removeItem("nome_razao_social_logado");
    sessionStorage.removeItem("nome_usuario_logado");
    sessionStorage.removeItem("id_loja_usuario");
    sessionStorage.removeItem("hash_usuario");
    sessionStorage.removeItem("usuario_compras_faturado");
    setUsuarioEfetuouLogin("");
    history.push('/index');
    api.post(`/Login/logout`, {}, { withCredentials: true })
        .then((response) => {
            history.push('/index');
        })
        .catch((error) => {
            console.log("REsP Ruim ", error);
            if (error == "Error: Network Error") {
                toastMensagemError("Ops, Alguma Coisa Errada com Nosso Servidor!");
                return null;
            }
        });
}

  const travado = () => {    
    if (showingToast === 0) {
      setShowingToast(1);
      setDestinoPagina("home");
      toastMensagemError("SOMENTE PARA CLIENTES FATURADOS!");      
      history.push("/");
      return;
    }
  }

  const needLogin = () => {
    if (showingToast === 0) {      
      setShowingToast(1);
      setDestinoPagina("minha_conta");
      toastMensagemErrorLogin("NECESSÁRIO EFETUAR LOGIN!");      
      history.push("/login");
      // return;
    }
  }      

  function identificacaoUsuarioLogado(){
    if (sessionStorage.getItem("id_loja_usuario") == null || sessionStorage.getItem("id_loja_usuario") == ""){
       return "";        
    }
    return (Buffer.from( sessionStorage.getItem("id_loja_usuario").replace('YfhR7sFdS53a==','').substring(2) , 'base64').toString());
  }  

  const toastMensagemError = (message) => toast.error(message,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });
  
  return (
    <div>
      <BrowserView>
        <NavBarTop />

        <Grid container justify="center">
          <Box sx={{
            display: 'flex',
            flexWrap: 'wrap',
            '& > :not(style)': {
              m: 1,
              width: '90%',
              height: '100%',
            },
            alignContent: 'center',
            justifyContent: 'center',
            marginTop: '100px',
            marginBottom: '100px',
          }}
          >
            <Paper elevation={1} style={{ backgroundColor: '#f5f5dc', height: "100%", marginTop: "10px" }}>
              <Grid container>

                { aguardandoCodigoVerificacao ? (
                  <div>
                  <Grid item xs={12}>                  
                    <Grid container>
                      <Grid item xs={12}>
                          
                      <Grid container>
                        <Grid item xs={12}>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "center", // centraliza o grupo
                            alignItems: "center",
                          }}
                        >
                          <ChaveIcon style={{ color: "green", width: "80px", height: "80px", marginLeft: "10px" }}/>
                          <h1 style={{ marginBottom:"30px", marginLeft: "10px" }}>Código de Verificação</h1>
                       </Box>
                        </Grid>
                     

                        </Grid>

                      </Grid>                    
                      <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} style={{ marginTop: '2px' }}>
                        <Box sx={{ marginTop: "5px", marginLeft: "65px" }}>                                            
                        <Typography variant='h7'>
                          Enviamos um e-mail contendo o seu código de acesso para { mascararEmail(usuarioEfetuouLoginEMail) }
                        </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={12}>          
                        <Box sx={{ textAlign: "center" }}>
                          <Typography variant="h6" sx={{ mt:1 }}>
                            Digite o código de 6 dígitos
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center", // ✅ centraliza horizontalmente
                              alignItems: "center", // centraliza verticalmente (opcional)
                              mt: 1,
                            }}
                          >
                          <OtpInput
                            value={otp}
                            onChange={handleChange}
                            numInputs={6}
                            renderSeparator={<span> </span>}
                            renderInput={(props) => (
                              <input
                                {...props}
                                style={{
                                  width: "3rem",
                                  height: "3rem",
                                  margin: "0.5rem",
                                  fontSize: "1.5rem",
                                  borderRadius: "8px",
                                  border: "1px solid #ccc",
                                  textAlign: "center",
                                }}
                              />
                            )}
                          />    
                          </Box>
                        </Box>

                        <Grid item xs={12} sx={{ height: "100vh" }}>
                          <Box marginBottom={'20px'}>
                            <Button onClick={e => handleBotaoVerificar(e) } variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', width: '110px', marginTop: '11px' }}>Verificar</Button>
                            <Button onClick={e => handleBotaoReenviar(e) } variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', width: '110px', marginTop: '11px', marginLeft: '15px' }}>Reenviar</Button>
                            <Button onClick={e => handleBotaoCancelar() } variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', width: '110px', marginTop: '11px', marginLeft: '15px' }}>Cancelar</Button>
                          </Box>
                        </Grid>

                        <Grid item xs={12} sx={{ height: "100vh" }}>
                          <Box marginBottom={'20px'}>
                            <Typography variant='h11' paddingLeft={'8px'} sx={{ color: message.toLowerCase().includes("não") || message.toLowerCase().includes("incorreto") || message.toLowerCase().includes("expirado") ? "red" : "blue", fontWeight: "bold" }}>{message}</Typography>
                          </Box>
                        </Grid>

                      </Grid>                      
                    </Grid>                    
                  </Grid>
                  </div>
                ) 
                :
                (
                  <div>
                <Grid item xs={6} sx={{ height: "100vh" }}>
                  <UsuarioIcon style={{ color: "green", width: "180px", height: "180px", marginTop: "45px" }}/>
                </Grid>
                <Grid item xs={6}>                  
                  <Grid container>
                    <Grid item xs={12}>
                      <Button variant="contained" onClick={(e) => handleOpenDadosPessoais(e)} style={{ backgroundColor: '#357a38', marginTop: '25px' }}>MEUS DADOS PESSOAIS</Button>
                    </Grid>                    
                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} style={{ marginTop: '2px' }}>
                      <Box sx={{ marginTop: "5px", marginLeft: "65px" }}>                                            
                        <ModalEnderecos props={usuarioEfetuouLogin} />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Box sx={{ marginTop: "25px", marginLeft: "65px" }}>
                        <ModalContatos props={usuarioEfetuouLogin} sx={{ minWidth: "257px" }} />
                      </Box>
                    </Grid>
                    <Grid item xs={12}>
                      <Button variant="contained" onClick={(e) =>deslogar(e)} style={{ backgroundColor: '#357a38', marginTop: '30px', marginBottom: '25px', minWidth:"192px" }}>Efetuar Logoff</Button>
                    </Grid>
                  </Grid>                    
                </Grid>
                </div>
                )}
              </Grid>

            </Paper>
          </Box>
        </Grid>
        <Rodape /> 
      </BrowserView>

      <MobileView>
        <NavBarTop />
        <Grid container justify="center">
        <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        '& > :not(style)': {
          m: 1,
          width: '90%',
          height: '100%',
        },
        alignContent: 'center',
        justifyContent: 'center',
        marginTop: '100px',
        marginBottom: '100px',
        }}
        >
        <Paper elevation={1} style={{ backgroundColor: '#f5f5dc', height: "100%", marginTop: "10px" }}>
          <Grid container>

            { aguardandoCodigoVerificacao ? (
              <div>
              <Grid item xs={12}>                  
                <Grid container>
                  <Grid item xs={12}>
                      
                  <Grid container>
                    <Grid item xs={12}>
                    <Box sx={{
                        display: "flex",
                        justifyContent: "center", // centraliza o grupo
                        alignItems: "center",
                      }}
                    >
                      <ChaveIcon style={{ color: "green", width: "40px", height: "40px", marginLeft: "5px" }}/>
                      <h4 style={{ marginBottom:"30px", marginLeft: "10px" }}>Código de Verificação</h4>
                    </Box>
                    </Grid>
                  

                    </Grid>

                  </Grid>                    
                  <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} style={{ marginTop: '2px' }}>
                    <Box sx={{ marginTop: "5px", marginLeft: "35px" }}>                                            
                    <Typography variant='h7'>
                      Enviamos um e-mail contendo o seu código de acesso para { mascararEmail(usuarioEfetuouLoginEMail) }
                    </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>          
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="h7" sx={{ mt:1 }}>
                        Digite o código de 6 dígitos
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "center", // ✅ centraliza horizontalmente
                          alignItems: "center", // centraliza verticalmente (opcional)
                          mt: 1,
                        }}
                      >
                      <OtpInput
                        value={otp}
                        onChange={handleChange}
                        numInputs={6}
                        renderSeparator={<span> </span>}
                        renderInput={(props) => (
                          <input
                            {...props}
                            style={{
                              width: "2rem",
                              height: "2rem",
                              margin: "0.4rem",
                              fontSize: "1.2rem",
                              borderRadius: "8px",
                              border: "1px solid #ccc",
                              textAlign: "center",
                            }}
                          />
                        )}
                      />    
                      </Box>
                    </Box>

                    <Grid item xs={12} sx={{ height: "100vh" }}>
                      <Box marginBottom={'20px'}>
                        <Button onClick={e => handleBotaoVerificar(e) } variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', width: '100px', marginTop: '11px' }}>Verificar</Button>
                        <Button onClick={e => handleBotaoReenviar(e) } variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', width: '100px', marginTop: '11px', marginLeft: '15px' }}>Reenviar</Button>
                        <Button onClick={e => handleBotaoCancelar() } variant="contained" style={{ backgroundColor: '#357a38', maxHeight: '35px', width: '100px', marginTop: '11px', marginLeft: '15px' }}>Cancelar</Button>
                      </Box>
                    </Grid>

                    <Grid item xs={12} sx={{ height: "100vh" }}>
                      <Box marginBottom={'20px'}>
                        <Typography variant='h11' paddingLeft={'8px'} sx={{ color: message.toLowerCase().includes("não") || message.toLowerCase().includes("incorreto") || message.toLowerCase().includes("expirado") ? "red" : "blue", fontWeight: "bold" }}>{message}</Typography>
                      </Box>
                    </Grid>

                  </Grid>                      
                </Grid>                    
              </Grid>
              </div>
            ) 
            :
            (
              <div>
            <Grid item xs={6} sx={{ height: "100vh" }}>
              <UsuarioIcon style={{ color: "green", width: "180px", height: "180px", marginTop: "45px" }}/>
            </Grid>
            <Grid item xs={6}>                  
              <Grid container>
                <Grid item xs={12}>
                  <Button variant="contained" onClick={(e) => handleOpenDadosPessoais(e)} style={{ backgroundColor: '#357a38', marginTop: '25px' }}>MEUS DADOS PESSOAIS</Button>
                </Grid>                    
                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} style={{ marginTop: '2px' }}>
                  <Box sx={{ marginTop: "5px", marginLeft: "65px" }}>                                            
                    <ModalEnderecos props={usuarioEfetuouLogin} />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ marginTop: "25px", marginLeft: "65px" }}>
                    <ModalContatos props={usuarioEfetuouLogin} sx={{ minWidth: "257px" }} />
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Button variant="contained" onClick={(e) =>deslogar(e)} style={{ backgroundColor: '#357a38', marginTop: '30px', marginBottom: '25px', minWidth:"192px" }}>Logoff</Button>
                </Grid>
              </Grid>                    
            </Grid>
            </div>
            )}
          </Grid>
          
        </Paper>
        </Box>
        </Grid>
        <Rodape />         
      </MobileView>

      <ToastContainer />
    </div>
  );

}
